<template>
  <el-container v-if="visitSource == 2" style="background: #F7F7F7 ">
    <!-- 左侧栏目菜单 -->
    <el-aside :width="isCollapse?'64px':'230px'" :style="'margin-right: 0px;' + ('background-color:' + menuColorMap[menuColorState].backgroundColor + ';')">
      <!-- <el-container >
        <el-main style="padding:10px 5px;"> -->
          <el-scrollbar style="height: 100%;">
            <div style="height:30px;position: relative;">
              <img v-if="programaSetInfo && programaSetInfo.company_logo" :src="GLOBAL.getFileServeUrl()+programaSetInfo.company_logo" alt="Logo" style="margin: 5px 10px 0px 10px;width: 120px;height: 30px;display: inline-block">
              <el-button @click="changeMenuStyle('black')" style="background: #000;position: absolute;left: 140px;margin: 10px 0px 0px 0px;" icon="" size="mini" circle></el-button>
              <el-button @click="changeMenuStyle('white')" style="background: #fff;position: absolute;left: 160px;margin: 10px 0px 0px 0px;" icon="" size="mini" circle></el-button>
              <el-button @click="changeMenuStyle('blue')" style="background: #1a86ee;position: absolute;left: 180px;margin: 10px 0px 0px 0px;" icon="" size="mini" circle></el-button>
              <!-- <el-switch style="position: absolute;left: 140px;margin: 5px 0px;" v-model="menuColorState" active-color="#111638" inactive-color="#1a86ee"></el-switch> -->
            </div>
            <el-divider style=""></el-divider>
            <!-- <el-button class="shoppingMall">商城<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
            <el-menu :style="'height:'+windowHeight+'px;'" :default-active="default_active" :class="'el-menu-vertical-demo ' + (menuColorState)" @open="handleOpen" @close="handleClose" :collapse="isCollapse" :background-color="'transparent'" :text-color="menuColorMap[menuColorState].color" :active-text-color="menuColorMap[menuColorState].color" @select="handleSelect" unique-opened :collapse-transition="false"
            >
                <el-menu-tree v-for="(item,index) in menuList" :key="item.menuId" :menuOne="item" :floor="'0'" :index="index+''" :isCollapse="isCollapse"></el-menu-tree>
            </el-menu>
          </el-scrollbar>
        <!-- </el-main>
      </el-container> -->
    </el-aside>
    <el-container :style="'height:'+(windowHeight+50)+'px;padding: 5px 5px 0px 0px;'" >
      <!--头部菜单-->
      <el-header height="40px" style="box-shadow:0px 15px 10px -15px #ccc;">
        <div style="display: flex;align-items: center">
          <div style="">
            <!-- <el-button class="openClose" type="info" :icon="img_collapse" @click="changeCollapse" ></el-button> -->
            <i :class="!isCollapse?'el-icon-s-fold':'el-icon-s-unfold'" @click="changeCollapse" style="font-size:20px"></i>
          </div>
          <el-tabs v-model="activeName" type="card" closable @tab-remove="removeTab" class="lmf-tabs" :style="'width:'+headWidth+'px;'" @contextmenu.prevent.native="openContextMenu($event)">
            <!-- <el-tab-pane
              label="直播间"
              name="LiveRoom"
            >
              <LiveRoom ></LiveRoom>
            </el-tab-pane> -->
            <el-tab-pane style="background: #1b4bce;"
              label="数据看板"
              name="DataBoard"
            >
              <!-- <DataBoard @checkTabExists="checkTabExists" @setMsgNum="setMsgNum"></DataBoard> -->
            </el-tab-pane>
            <el-tab-pane 
              v-for="item in editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            >
            </el-tab-pane>
          </el-tabs>
          <el-popover style="position:absolute;right:0;margin-right: 20px" placement="top-start" width="250" trigger="hover" >
            <div>
              <div style="display: flex;align-items: center;">
                <el-avatar :src="avatarUrl"></el-avatar><span style="padding-right: 5px;">{{loginInfo.USERNAME}}</span>  
              </div>
              <el-divider></el-divider>
              <div class="list_"><i class="el-icon-bank-card"></i>{{sessionMap.roleNames}}</div>
              <!-- <div class="list_"><i class="el-icon-message"></i><el-badge :value="msgNum" >未读消息</el-badge></div>
              <div class="list_"><i class="el-icon-coin"></i>会员积分<img src="./img/VIP.png" alt="vip" class="VIP_s"></div> -->
              <el-divider></el-divider>
              <el-button class="signOut" @click="loginOut" icon="el-icon-switch-button">退出</el-button>
            </div>
            <div slot="reference"  class="head_new">
              <el-avatar :src="avatarUrl"></el-avatar>
            </div>
          </el-popover>
        </div>
      </el-header>
      <!-- 右侧主框架信息  -->
      <el-main :style="'padding:0px 5px 0px 0px;overflow: auto;height:'+(windowHeight+10) + 'px;'" >
        <div v-show="activeName == 'DataBoard'"> <!--  :style="(activeName == 'DataBoard'?'':'visibility:hidden')+'z-index'"  -->
          <kw_data_console></kw_data_console>
        </div>
        <div v-for="item in editableTabs" :key="item.name +(item.refreshIndex?item.refreshIndex:'0')" v-show="activeName == item.name" ><!--  :style="activeName == item.name?'':'visibility:hidden'" -->
          <!-- <template v-if="activeName == item.name"> -->
            <Report v-if="item.actionWay == 3" :ref="'listPage_'+item.menuId" :pageInfo="item" :initReportType=0 >
            </Report>
            <!-- <kw_list v-else-if="item.columnType == 2" :initPageObj="item" :isLimitButton="true"></kw_list> -->
            <!-- <iframe v-if="item.actionWay == 2" :id="'tabIframe'+item.menuId" :style="'width:100%;height:'+(windowHeight-25)+'px;'" frameborder=0 name="showHere" scrolling=auto :src="item.url">
            </iframe> -->
            <kw_look v-if="item.actionWay == 2" :pageInfo="item" :isLimitButton="true" ></kw_look>
            <iframe v-else-if="item.actionWay == 1" :id="'tabIframe'+item.menuId" :style="'width:100%;height:'+(windowHeight-25)+'px;'" frameborder=0 name="showHere" scrolling=auto :src="item.url"></iframe>
            <iframe v-else :id="'tabIframe'+item.menuId" :style="'width:100%;height:'+(windowHeight-25)+'px;'" frameborder=0 name="showHere" scrolling=auto :src="item.url"></iframe>
            <!-- <kw_list v-else :ref="'kw_list_'+(item.refreshIndex?item.refreshIndex:'0')" :initPageObj="item" :isLimitButton="true" @goBack="goBack(item)"></kw_list> -->
          <!-- </template> -->
        </div>
        <ul
          v-show="tabContextMenuInfo.contextMenuVisible"
          :style="{left:tabContextMenuInfo.left+'px',top:tabContextMenuInfo.top+'px'}"
          class="contextmenu"
        >
          <li @click="closeAllTabs">关闭所有</li>
          <li @click="closeOtherTabs('left')">关闭左边</li>
          <li @click="closeOtherTabs('right')">关闭右边</li>
          <li @click="closeOtherTabs('other')">关闭其他</li>
        </ul>
      </el-main>
    </el-container>
  </el-container>
  <div v-else style="padding-bottom: 50px;">
    <template  v-if="activeHomeBarOne.ifLoaded" >
      <kw_list :key="'homeTab_'+activeHomeBarOne.barKey + '_' + activeHomeBarOne.mainId" v-if="activeHomeBarOne.pageType == 1" :ref="activeHomeBarOne.barKey==1?'kw_list':'kw_list_'+activeHomeBarOne.barKey" :initPageObj="activeHomeBarOne" ></kw_list>
      <kw_look :key="'homeTab_'+activeHomeBarOne.barKey + '_' + activeHomeBarOne.mainId" v-else :ref="activeHomeBarOne.barKey==1?'kw_look':'kw_look_'+activeHomeBarOne.barKey" :pageInfo="activeHomeBarOne"></kw_look>
    </template>
    <div class="button_menu">
      <template v-for="(item,index) in homeBarArr">
        <div :key="'homeTab_'+index" class="item_menu" :style="'width:'+(100/homeBarShowLength)+'%'"  @click="menuHandleClick(index+'')" v-if="item.ifShow==1">
        <i :class="(activeName == index)?('active_menu'+' '+item.barCurrentIcon):(''+item.barCurrentIcon)" style="font-size: 20px"></i>
        <div class="title_menu" :class="activeName == index?'active_menu':''">{{item.barName}}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DataBoard from '@/components/page/DataBoard.vue';
import elMenuTree from '@/pages/home/el-menu-tree.vue';
//角色看板组件
import kw_data_console from '@/components/form/kw_data_console.vue';
import Report from '@/components/page/Report.vue'
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'MainPage',
  data(){
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      //登陆人 人员信息
      loginInfo:{},
      //项目表中的信息
      programaSetInfo:null,
      //登录人 session中的信息
      sessionMap:null,
      //角色看板的信息
      roleWorkPlatArr:[],
      //角色看板默认选中第一个角色
      roleNameActive:'roleWorkPlat_0',
      //登陆人的按钮信息
      menuList:[],
      //是否切换深色菜单
      menuColorState:'black',
      menuColorMap:{
        blue:{
          backgroundColor:'#1a86ee',
          color:'#fff'
        },
        white:{
          backgroundColor:'#fff',
          color:'#000'
        },
        black:{
          backgroundColor:'#111638',
          color:'#fff'
        }
      },
      default_active:'',
      systemMenuList:[{
        menuName:"对象管理",
        title:"对象管理",
        systemType:1,
        menuId:-1,
        actionWay:1,
        parent_menuId: -1
      },{
        menuName:"页面管理",
        title:"页面管理",
        systemType:4,
        menuId:-4,
        actionWay:1,
        parent_menuId: -1
      },{
        menuName:"栏目管理",
        title:"栏目管理",
        systemType:3,
        menuId:-3,
        actionWay:1,
        parent_menuId: -1
      },{
        menuName:"固定数据字典管理",
        title:"固定数据字典管理",
        systemType:5,
        menuId:-5,
        actionWay:1,
        parent_menuId: -1
      }],
      //当前打开的 选项卡名称(栏目ID)
      activeName:"DataBoard",//"DataBoard",
      //选项卡数组
      editableTabs: [],
      //左侧树形结构的收起展开状态
      isCollapse:false,
      //左侧栏目菜单的收起展开图片
      //el-icon-s-fold   el-icon-s-unfold
//      img_collapse:"el-icon-d-arrow-left",
      img_collapse:"el-icon-d-arrow-left",
      //未读消息个数
      msgNum:0,
      windowHeight:500,
      headWidth:500,
      avatarUrl: require("./img/headImg.png"),
      //菜单按钮
      tabContextMenuInfo:{
        contextMenuVisible:false,
        currentContextTabId:"",
        left:0,
        top:0
      },
      //H5同mailHome页面
      activeHomeBarOne:{},
      homeBarArr:[],
      homeBarShowLength:2,
      hasLoad:false,
    }
  },
  created:function(){
    var that = this;

    this.headWidth = window.innerWidth-250;
    var paramsJson = this.$route.query;
    if(paramsJson.proId) {
      localStorage.proId = paramsJson.proId;
    }
    that.initShamInfo(that);

    //  
    if(utils.isNull(localStorage.loginInfo)) {
      if(that.visitSource == 3) {
        if(that.$router.app.$children[0].openLogin) {
          that.$router.app.$children[0].openLogin();
        }
      } else {
        pageUtils.toLoginPage(this);
      }
    } else{
      //绑定用户信息
      this.loginInfo = JSON.parse(localStorage.loginInfo);
      var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");
      if(programaSetInfo) {
        this.programaSetInfo = JSON.parse(programaSetInfo);
      }
      if(localStorage.sessionMap) {
        this.sessionMap = JSON.parse(localStorage.sessionMap);
      }
      var roleWorkPlatArr = [];
      if(this.sessionMap && this.programaSetInfo) {
        var roleIds = this.sessionMap.roleIds;
        if(roleIds != null && roleIds != "") {
          var roleIdArr = roleIds.split(",");
          var roleNames = this.sessionMap.roleNames;
          var roleNameArr = roleNames.split(",");
          for (let index = 0; index < roleIdArr.length; index++) {
            const roleIdOne = roleIdArr[index];
            const roleNameOne = roleNameArr[index];
            if(this.programaSetInfo.CASTING_TABLE_ID > 0 && this.programaSetInfo.CASTING_PAGE_ID > 0) {
              var roleJosn = {
                tableId: this.programaSetInfo.CASTING_TABLE_ID,
                pageId: this.programaSetInfo.CASTING_PAGE_ID,
                pageType:11,
                mainId: roleIdOne,
                ifLoaded:true,
                roleId:roleIdOne,
                roleName:roleNameOne
              };
              var kwParam = "";
              var lookParam = that.GLOBAL.lookParam;
              lookParam.forEach(key => {
                  kwParam+=(roleJosn[key]?roleJosn[key]:"")+"_";
              });
              kwParam = utils.kwBtoa(kwParam);
              roleJosn.url = "look?noHead=1&kw_param=" + kwParam;
    
              roleWorkPlatArr.push(roleJosn);
            }
          }
        }
      }
      this.roleWorkPlatArr = roleWorkPlatArr;
      //登陆人的按钮列表信息
      var menuList = [];
      if(this.loginInfo.USERID == 0) {
        menuList = menuList.concat(this.systemMenuList);
      }
      if(localStorage.menuList && localStorage.menuList != 'undefined') {
        menuList = menuList.concat(JSON.parse(localStorage.menuList));
      }
      this.menuList = menuList;
      this.windowHeight = window.innerHeight-60;
      this.windowWidth = window.innerWidth;
    }
    pageUtils.flutterWebPageFinished();
    that.hasLoad = true;
  },
  methods: {
    initShamInfo(that) {
      if(!that) {
        that = this;
      }
      if(that.visitSource == 3) {
        that.activeName = "0";
        var homeMenuList = pageUtils.getHomeMenuList('mainPage');
        console.log("homeMenuList===================================",homeMenuList);
        if(utils.isNotNull(homeMenuList)) {
          that.homeBarArr = JSON.parse(homeMenuList);
        }
        that.menuHandleClick("0");
      }
    },
    changeMenuStyle(styleName) {
      this.menuColorState = styleName;
    },
    /**
     * 切换选中状态
     */
    changeCollapse(){
      this.isCollapse = !this.isCollapse;
    },

    handleOpen(key, keyPath) {
		console.log(key,keyPath)
    },
    handleClose(key, keyPath) {
		console.log(key,keyPath)
    },
    /**
     * 点击打开页面
     */
    handleSelect(key, keyPath) {
      //选中时 调用打开页面 
      var tmpMenuList = this.menuList; 
      var newkeyPath = key.split("_");
      var menuOne = {};
      for(var i = 0;i < newkeyPath.length; i ++) {
        menuOne = tmpMenuList[newkeyPath[i]];
        tmpMenuList = menuOne.meunColl;
      }
      this.checkTabExists(menuOne);
    },
    /**
     * 检查选项卡是否已经打开 如果没有则进行打开
     */
    checkTabExists(menuOne){
      var tabName = 'pageTab-' + menuOne.menuId;
      let tabs = this.editableTabs;
      var ifHasAdd = false;
      tabs.forEach((tab, index) => {
        if (tab.name === tabName) {
          ifHasAdd = true;
        }
      });
      console.log();
      if(!ifHasAdd) {
        this.addTab(menuOne);
      } else {
        //如果已经打开过默认选中选项卡
        this.activeName = tabName;
      }
    },
    /**
     * 新增页签信息(打开新页面)
     */
    addTab(menuOne) {
      var menuId = menuOne.menuId;
      var pageId = menuOne.pageId;
      var tableId = menuOne.tableId;
      var tabName = 'pageTab-' + menuId;
      menuOne.title = menuOne.menuName;
      menuOne.name = tabName;
      var httpUrl = ""; //链接地址
      //判断是不是管理员页面 
      if(menuOne.systemType>0) {
        if(menuOne.systemType == 1) {
          httpUrl = this.GLOBAL.baseURL+"object_toObjList.do";
        } else if(menuOne.systemType == 3) {
          httpUrl = this.GLOBAL.baseURL+"menu_toList.do";
        } else if(menuOne.systemType == 4) {
          httpUrl = this.GLOBAL.baseURL+"page_toPageList.do";
        } else if(menuOne.systemType == 5) {
          httpUrl = this.GLOBAL.baseURL+"regularDic_toRegularDicPage.do";
        }
      } else {
        if(!menuOne.actionWay || menuOne.actionWay == 0) {
          // httpUrl = this.GLOBAL.baseURL+"model_toList?pageType="+menuOne.pageType;
          // httpUrl+="&pageId="+ menuOne.pageId;
          // httpUrl+="&tableId="+ menuOne.tableId;
          // if(menuOne.ctType) {
          //   httpUrl+="&ctType="+ menuOne.ctType;
          // }
          // if(menuOne.SourceDataId) {
          //   httpUrl+="&SourceDataId="+ menuOne.SourceDataId;
          // }
          httpUrl = 'new_list?noHead=1&openWay=2&kw_param='+menuOne.tableId + "_"+menuOne.pageId+"_1_" + "_";
        } else if(menuOne.actionWay == 2){
          //look页面
          httpUrl = 'look?noHead=1&openWay=2&kw_param='+menuOne.tableId + "_"+menuOne.pageId+"_" + "_" + "_" + this.loginInfo.USERID +"_" + "_";
        } else if(menuOne.actionWay == 1) {
          httpUrl = menuOne.menuPageUrl;
          // if(menuOne.menuPageUrl && !menuOne.menuPageUrl.startsWith("http")) {
          // }
        } else {
          //列表页面
          httpUrl = 'new_list?noHead=1&openWay=2&kw_param='+menuOne.tableId + "_"+menuOne.pageId+"_1_" + "_";
          // httpUrl = menuOne.menuPageUrl;
        }
      }
      menuOne.url = httpUrl;
      if(menuOne.actionWay == 2 && menuOne.columnType == 1 && menuOne.tableId == 2 && !(menuOne.mainId>0)) {
        menuOne.mainId = this.loginInfo.USERID;
      }
      console.log("menuOne===========",menuOne);
      this.editableTabs.push(menuOne);
      this.activeName = tabName;
    },
    /**
     * 关闭选项卡(关闭页面)
     */
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.activeName;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      
      var editableTabs = tabs.filter(tab => tab.name !== targetName);
      if(editableTabs.length == 0) {
        activeName = "DataBoard";
      }
      this.activeName = activeName;
      this.editableTabs = editableTabs;
    },
    /**
     * 设置未读消息个数
     */
    setMsgNum(msgNum){
      this.msgNum = msgNum;
    },
    loginOut(){
      utils.loginOut(this);
    },
    openContextMenu(e) {
      console.log(e.srcElement);
      var id = e.srcElement.id;
      if (id) {
        let currentContextTabId = id.substring(id.indexOf("-")+1);
        this.tabContextMenuInfo.contextMenuVisible = true;
        this.tabContextMenuInfo.currentContextTabId = currentContextTabId;
        // this.$store.commit("saveCurContextTabId", currentContextTabId);
        this.tabContextMenuInfo.left = e.clientX;
        this.tabContextMenuInfo.top = e.clientY + 10;
      }
    },
    // 关闭所有标签页
    closeAllTabs() {
      // this.$store.commit("closeAllTabs");
      this.editableTabs = [];
      this.activeName = "DataBoard";
      this.tabContextMenuInfo.currentContextTabId = "";
      this.tabContextMenuInfo.contextMenuVisible = false;
    },
    // 关闭其它标签页
    closeOtherTabs(par) {
      var activeName = "";
      let tabs = this.editableTabs;
      var editableTabs = [];
      if(par == "other") {
        editableTabs = tabs.filter(tab => tab.name == this.tabContextMenuInfo.currentContextTabId);
      } else {
        var flag = 0;
        tabs.forEach((tab, index) => {
          if (tab.name === this.tabContextMenuInfo.currentContextTabId) {
            flag = 1;
            editableTabs.push(tab);
          } else if(par == "left" && flag == 1) {
            editableTabs.push(tab);
          } else if(par == "right" && flag == 0) {
            editableTabs.push(tab);
          }
        });
      } 
      if(editableTabs.length == 0) {
          activeName = "DataBoard";
        } else {
          activeName = this.tabContextMenuInfo.currentContextTabId
        }
      this.activeName = activeName;
      this.editableTabs = editableTabs;
      // this.$store.commit("closeOtherTabs", par);
      this.tabContextMenuInfo.currentContextTabId = "";
      this.tabContextMenuInfo.contextMenuVisible = false;
    },
    // 关闭contextMenu
    closeContextMenu() {
      this.tabContextMenuInfo.currentContextTabId = "";
      this.tabContextMenuInfo.contextMenuVisible = false;
    },
    //H5 标签切换方法
    menuHandleClick:function(index){
      var that = this;
      console.log("menuHandleClick------------------",index);
      var tmp = that.homeBarArr;
      var indexArr = index.split("_");
      indexArr.forEach(oneIndex => {
        if(tmp.childMenu) {
          tmp = tmp.childMenu[oneIndex];
        } else {
          tmp = tmp[oneIndex];
        }
      });
      that.handleClickPageOne(tmp);
      that.activeName = index+'';
    },
    handleClickPageOne(pageOne) {
     var that = this;
     // 登录人的信息
      if(utils.isNotNull(localStorage.loginInfo)) {
        that.loginInfo = JSON.parse(localStorage.loginInfo);
      }
     var loginInfo = that.loginInfo;
      var userId = -1;
      if(loginInfo) {
        userId = loginInfo.USERID;
      }
      console.log("loginInfo==============================",loginInfo);
      console.log("userId==============================",userId);
      // if (pageOne.ifLogin==1 && !(userId>0)) {
      // // 打开弹窗登录页面 登录后继续进行触发
      // // 如果未登录 进行打开登录页面的操作
      //   if(that.$router.app.$children[0].openLogin) {
      //     that.$router.app.$children[0].openLogin();
      //   }
      //   return;
      // }
      if (pageOne.ifLogin==1) {
        // if (userId > 0) {
          pageOne.mainId = userId;
          pageOne.ifLoaded = true;
        // }
      } else {
        pageOne.ifLoaded = true;
      }
      if(pageOne.pageId > 0) {
        that.activeHomeBarOne = pageOne;
      }
      console.log("activeHomeBarOne==============================",that.activeHomeBarOne,that.activeName);
    },
    goBack(item){
      //刷新当前页面
      console.log("MainPage--------------goBack----------------",item);
      this.$set(item,"refreshIndex",((item.refreshIndex?item.refreshIndex:0)+1));
    }
  },
  watch: {
    "tabContextMenuInfo.contextMenuVisible":function(value) {
      if (this.tabContextMenuInfo.contextMenuVisible) {
        document.body.addEventListener("click", this.closeContextMenu);
      } else {
        document.body.removeEventListener("click", this.closeContextMenu);
      }
    }
  },
  components:{
    DataBoard,
    elMenuTree,
    kw_data_console,
    Report,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve),
  },
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .el-header {
    background-color: #FFFFFF;
    color: #333;
    /*line-height: 60px;*/
    padding: 0;
  }
  
  .el-aside {
    color: #333;
  }


  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 230px;
    min-height: 400px;
  }
  
  .el-tabs--card> .el-tabs__item{border: none}
  .el-menu{
    border-right: none;
  }


  /* .head_new{display: flex;justify-content: center;align-items: center;float: right;height: 100%;color: #8C8C8C;padding: 0 10px} */
  .head_title span{display: block;line-height: 20px}
  .head_title .integral{border: 1px solid #ddd;border-radius: 10px;display: inline-block;text-align: center;margin-left: 5px;font-size: 12px;padding: 0 5px;line-height: 15px}

  .signOut{margin-top: 5px;width: 100%;height: 32px;line-height: 32px;padding: 0;text-align: center}
  .VIP_s{width: 25px;height: 12px;vertical-align: baseline;margin-left: 3px;}
  .headImg{width: 30px;height: 30px;background-repeat: no-repeat;}
  .shoppingMall{border:2px solid #E4252D;border-radius: 5px;color: #E4252D;font-weight: bold;padding: 3px 10px;font-size: 18px;margin-left: 10px}
  .openClose{border:2px solid #000;border-radius: 5px;color: #000;background-color:#fff;font-weight: bold;padding: 3px 10px;font-size: 18px;margin: 3px 0 10px 10px;}
  .el-icon-arrow-right{font-weight: bold;border:1px solid #E4252D;border-radius: 20px}
  .list_{padding: 3px;display: flex;align-items: center;}

  .el-divider--horizontal{margin: 10px 0;}
  .el_popover{overflow-y: visible;}

  /* 选项卡右键事件 */
  .contextmenu {
    width: 100px;
    margin: 0;
    border: 1px solid #ccc;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);
  }
  .contextmenu li {
    margin: 0;
    padding: 7px 16px;
  }
  .contextmenu li:hover {
    background: #f2f2f2;
    cursor: pointer;
  }

  .button_menu{position: fixed;left: 0;right: 0;bottom: 0;background: #fff;height: 50px;border-top: 1px solid #e9eaec;padding-top: 5px}
 .item_menu{text-align: center;display: inline-block;}
 .title_menu{font-size: 12px}
 .active_menu{color: #f759ab}


</style>
<style>
  .lmf-tabs .el-tabs__nav{border: 0px !important;}
  .lmf-tabs .el-tabs__nav-scroll{line-height: 40px}
  .lmf-tabs .el-tabs__item:hover{color: #303133}
  .lmf-tabs .el-tabs__item.is-active {background: #409EFF;color: #fff!important;;height: 30px;line-height: 26px;border-radius: 3px;border: 1px solid #409EFF;font-size: 12px;}
  .lmf-tabs .el-tabs__item{margin: 0 3px !important;padding: 0 10px !important;color:#495060 !important;height: 30px !important;line-height: 26px !important;border-radius: 3px !important;border: 1px solid #d8dce5 !important;font-size: 12px !important;}

  /* 左侧菜单栏的鼠标移上和选中样式 */
  .black .el-submenu__title:hover{background-color: rgb(204,204,204) !important; }
  .black .el-menu-item:hover {background-color: rgb(204,204,204) !important;}
  .black .el-menu-item.is-active {background-color: #1a86ee !important;}

  .blue .el-submenu__title:hover{background-color: rgb(204,204,204) !important; }
  .blue .el-menu-item:hover {background-color: rgb(204,204,204) !important;}
  .blue .el-menu-item.is-active {background-color: #000 !important;}

  .white .el-submenu__title:hover{background-color: rgb(204,204,204) !important; }
  .white .el-menu-item:hover {background-color: rgb(204,204,204) !important;}
  .white .el-menu-item.is-active {background-color: #1a86ee !important;}
</style>
